export default __webpack_public_path__ + "static/wanaka-new-zealand-821589a4a3778d93dd2ba72f1bc56515.jpg";